<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <EtablissementSection />
  <AdresseEmployeur />
</template>

<script setup lang="ts">
  import AdresseEmployeur from './sections/adresseEmployeur/AdresseEmployeurSection.vue'
  import EtablissementSection from './sections/etablissement/EtablissementSection.vue'
</script>
